export default {
  title: 'KeyPal이 지원하는 블록체인 목록 (1000+)',
  getKeypal: 'KeyPal 받기',
  comingSoon: '곧 출시 예정',
  list: {
    title: '블록체인',
    detail: '세부정보',
    urlName: '링크',
  },
}
